import { cn } from "@/lib/utils";

// Instant zero-lag synchronous render (100% visible immediately, no opacity:0 locks)
export const Reveal = ({ children, className, as: Tag = "div", ...props }) => {
  return (
    <Tag className={cn(className)} {...props}>
      {children}
    </Tag>
  );
};
